import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Theme } from '@material-ui/core';



const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        paddingTop: 50

    },
    container: {
        display: "flex-grow",
    }
}));

function NoAccess(props:any) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Grid container spacing={0} className={classes.container} alignContent="center">
                <Grid item xs={12}>
                    <h2>Unauthorized Access </h2>
                </Grid>
            </Grid>
        </div>
    );
}

export default NoAccess;